import React, {useState} from "react";
import {  Container, Jumbotron, Form, FormGroup, Button } from 'reactstrap';
import CovidStep1 from "./covid-step1";
import CovidStep2 from "./covid-step2";
import CovidStepFinal from "./covid-step-final";
import useGlobal, {defaultAnswers} from "../utils/globalStore";
import CovidStep3 from "./covid-step3";
import {ValidateStore} from "../api/stores-api";

function CovidPage(props) {

    const [answers, updateAnswer] = useState(defaultAnswers);
    const [globalState, globalActions] = useGlobal();
    const localStates = {};


    const handleChange = (e) => {
        const { name, value, type } = e.target;
        if(type === 'checkbox'){
            const item = e.target.name;
            const isChecked = e.target.checked;
            updateAnswer(prevState => ({...prevState, symptoms: prevState.symptoms.set(item,isChecked)}))
            globalActions.updateState(answers);
        }
        else{
            updateAnswer((prevState) => {
                const newState = {...prevState, [name]: value}
                return newState;
            })
            globalActions.updateState(name,value);
        }
    }

    return (

        <div >
            <div>
                <Jumbotron style={{backgroundColor: '#03787C'}} >
                    <h1 className="display-6" style={{color:'white'}}>COVID-19 Screening Form</h1>
                    <hr className="my-2"  />
                    <h6 style={{color:'white'}}>7-Eleven is committed to the safety and well-being of our employees and customers.  As part of our ongoing commitment to keeping employees and customers safe from COVID-19, we are further expanding our COVID-19-related protocols to include employee screening questionnaires for completion prior to each shift. </h6>
                    <p>{' '}</p>
                    <h6 style={{color:'white'}}>Note that if you are experiencing COVID-19 symptoms or have been in close contact with a possible or confirmed case of COVID-19, you must promptly call your supervisor, and you must not report to work.  This does not replace any state or local mandate regarding employee prescreen requirements. For store employees who report to work, Store Leaders and Assistant Store Leaders shall provide any additional screening form for completion immediately after the employees clock in for their shifts. </h6>
                </Jumbotron>
            </div>
            {displayPagination(props,answers,handleChange,globalState, localStates)}

        </div>
    );
}

const getPage = (current, answers, handleChange, references) => {
    //console.log('Current :' + current);
    const pages = [CovidStep1,CovidStep2,CovidStep3,  CovidStepFinal]
    return(pages[current-1]({"answers": answers, "handleChange" : handleChange, "references": references}))
}

const updateState = (localStates,index, name, value) => {
    if(localStates && localStates[index]){
        const updateLocalState = localStates[index]
        updateLocalState(prevState => {
            const newState = {...prevState, [name]: value}
            return newState
        });
    }


}

const validateStore = async (answers, localStates) => {
    let  valid = false;
    const safenameRegex = /^[a-zA-Z0-9 .-]+$/;

    if(answers.store && answers.associateName){
        const found = await ValidateStore(answers.store)();
        if(found){
            valid = true;
            updateState(localStates,1,"store", {valid: true});
        }
        else {
            valid = false;
            console.log("Store not found :" + answers.store);
            updateState(localStates,1,"store",  {valid: false});
        }


        if(safenameRegex.test(answers.associateName)){
            //invalid characters
            updateState(localStates,1,"associateName", {valid: true});
            valid = valid & true;
        }
        else {
            updateState(localStates,1,"associateName", {valid: false});
            console.log("invalid name :" + answers.associateName);
            valid = valid & false;
        }

    }
    return valid;
}

const validateSyptoms = (answers) => {
    if(answers.symptomsYesNo){
        return true;
    }
    else{
        return false;
    }
}

const validateContact = (answers) => {
    if(answers.contactYesNo){
        return true;
    }
    else{
        return false;
    }

}

const handleNext = async (form, props, globalState, next,jumpto,localStates) => {
    let valid = false;
    //console.log("handleNext answers " + JSON.stringify(globalState.answers));

    if(globalState && globalState.answers) {
        if (props.current === 1) {
            valid = await validateStore(globalState.answers, localStates);
        } else if (props.current === 2 ) {
            valid = validateSyptoms(globalState.answers);
        } else if (props.current === 3) {
            valid = validateContact(globalState.answers);
        // } else if (props.current === 4) {
        //     valid = validateTracing(globalState.answers, localStates);
        } else {
            valid = true;
        }
    }
    //console.log("handleNext current " + props.current + "," + valid);
    if(valid){
        //handleOptionalFlow(props, next, jumpto, globalState);
        next();
    }

    return valid;
}


const displayPagination = (props, answers,handleChange,globalState,  localStates) =>{
    const first = props.isFirst()| props.isLast() ? "" : <Button  onClick={props.prev} style={{backgroundColor: '#03787C'}}>Previous</Button> ;
    const last = (props) => {
        let last;
        if(props.isLast()){
            last = <a href="/hr/covid/">Submit another response</a>
        }
        else if(props.current === props.size-1){
            last = <Button  style={{backgroundColor: '#03787C'}} onClick={ () => handleNext(this, props, globalState,props.next,props.jump,localStates)}>Submit</Button>
        }
        else{
            last = <Button  style={{backgroundColor: '#03787C'}} onClick={ () => handleNext(this, props, globalState,props.next,props.jump,localStates)}>Next</Button>
        }
        return last;
    }
    const pagination = <FormGroup>
                            {first}
                            {'     '}
                            {last(props)}
                        </FormGroup>

    const page = <div className="container-fluid" >
        <Container className="themed-container" fluid={true}>
            <Form>
                <div style={{textAlign: 'left'}}>{getPage(props.current, answers, handleChange,localStates)}</div>
                {pagination}
            </Form>
        </Container>
    </div>


    return (
        page
    );
}

export default CovidPage;